import Vue from 'vue'
import SvgIcon from '@ms/components/SvgIcon' // svg component
import InlineSvg from '@ms/components/InlineSvg' // svg component

// register globally
Vue.component('SvgIcon', SvgIcon)
Vue.component(InlineSvg.name, InlineSvg)

/* 不要全局注册，在使用的地方按需引入
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
 */
